require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 857
// module chunks = 0